import { Spin } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { PcodeRendererCanvas } from '../../service/Pcode/PcodeCanvas';
import { Size } from '../../typings/common';
import { PcodeRenderDataCanvas } from '../../typings/pcode';

import './PcodeCanvasPreview.css';

export enum LoadingStatus {
    NOT_STARTED = 'NOT_STARTED',
    PROGRESS = 'PROGRESS',
    SUCCESS = 'SUCCESS'
}

export interface PcodeCanvasPreviewProps {
    pcodeData?: PcodeRenderDataCanvas;
    currentSize?: Size;
}

interface PcodeCanvasPreviewState {
    loadingStatus: LoadingStatus;
}

const BLOCK = 'pcode-canvas-preview';

export class PcodeCanvasPreview extends React.Component<PcodeCanvasPreviewProps, PcodeCanvasPreviewState> {
    state: PcodeCanvasPreviewState = {
        loadingStatus: LoadingStatus.NOT_STARTED
    };
    private renderNode = React.createRef<HTMLDivElement>();
    private pcodeRenderer: PcodeRendererCanvas | undefined;

    onExternalDataReceived(pcodeData: PcodeRenderDataCanvas, hasAnimation: boolean) {
        this.updatePreviewData(pcodeData, hasAnimation);
    }

    shouldComponentUpdate(nextProps: PcodeCanvasPreviewProps, nextState: PcodeCanvasPreviewState) {
        return nextState.loadingStatus !== this.state.loadingStatus;
    }

    componentDidMount() {
        if (this.props.pcodeData) {
            this.updatePreviewData(this.props.pcodeData, false);
        }
    }

    render() {
        let previewStyle = {};

        if (this.props.currentSize) {
            const { width, height } = this.props.currentSize;
            previewStyle = { width: `${width}px`, height: `${height}px` };
        }

        const inProgress = this.state.loadingStatus === LoadingStatus.PROGRESS;

        return (
            <div className={Bem.cls(BLOCK)} style={previewStyle}>
                <div className={Bem.cls(BLOCK, 'spin')}>
                    <Spin size={'s'} progress={inProgress} />
                </div>
                <div key={'pcode-preview-key'} ref={this.renderNode} />
            </div>
        );
    }

    private updatePreviewData(pcodeData: PcodeRenderDataCanvas, hasAnimation: boolean) {
        this.setState({
            loadingStatus: LoadingStatus.PROGRESS
        });

        const pcodeRenderer = this.getPcodeRenderer();

        pcodeRenderer.updatePreviewData(pcodeData, hasAnimation);
    }

    private getPcodeRenderer() {
        if (!this.pcodeRenderer) {
            const renderNode = this.renderNode.current;

            this.pcodeRenderer = new PcodeRendererCanvas(renderNode, {
                onRender: this.onPcodePreviewRendered,
                onUpdate: this.onPcodePreviewUpdated
            });
        }

        return this.pcodeRenderer;
    }

    private onPcodePreviewRendered = () => {
        this.setState({
            loadingStatus: LoadingStatus.SUCCESS
        });
    };

    private onPcodePreviewUpdated = () => {
        this.setState({
            loadingStatus: LoadingStatus.SUCCESS
        });
    };
}
